<template>
  <b-modal
    v-model="show"
    centered
    size="sm"
    hide-header
    footer-class="border-top m-auto w-100 reset-footer"
    body-class="p-3"
    @ok="onOk"
    @cancel="onCancel"
    :ok-title="hebrew ? 'מחק' : 'Delete'"
    :cancel-title="hebrew ? 'ביטול' : 'Cancel'"
  >
    <div class="text-center">
      {{hebrew ? 'האם אתה בטוח שברצונך' : 'Are you sure you want to'}}
      <br>
  {{hebrew ? 'למחוק את הטקסט' : 'delete current text'}}?
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="checkboxAsk" class="custom-control-input" v-model="checked" @change="preventResetDialog">
        <label for="checkboxAsk" class="custom-control-label">
          {{hebrew ? 'אל תציג שוב' : 'Don\'t show again'}}
        </label>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "ResetDialog",
  props: ["value"],
  data() {
    return {
      checked: false
    };
  },  
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
      preventResetDialog () {
        localStorage.setItem("NOT_ASK", this.checked)
      },
      onCancel () {
         this.$emit("dialogClick", {clicked:false, dontShowAgain: this.checked})
      },
      onOk () {
          this.$emit("dialogClick", {clicked:true, dontShowAgain: this.checked})
      }
  }
};
</script>
<style lang="scss">
  .reset-footer{
    button{
      width:50%;
    }
  }
</style>